module.exports = __webpack_public_path__ + "img/mail_top_image.88d7e07f.png";